import { useState, useEffect } from 'react';

/**
 * Detecta la apertura del teclado virtual en móvil usando window.visualViewport.
 * En iOS Safari y Android Chrome, window.visualViewport.height se reduce cuando
 * se abre el teclado, mientras que window.innerHeight permanece constante.
 *
 * @returns {{ viewportHeight: number, keyboardOpen: boolean, keyboardHeight: number }}
 */
const useVisualViewport = () => {
    const [viewportHeight, setViewportHeight] = useState(
        window.visualViewport ? window.visualViewport.height : window.innerHeight
    );
    const [windowHeight] = useState(window.innerHeight);

    useEffect(() => {
        const vv = window.visualViewport;
        if (!vv) return;

        const handler = () => {
            setViewportHeight(vv.height);
        };

        vv.addEventListener('resize', handler);
        return () => vv.removeEventListener('resize', handler);
    }, []);

    const keyboardHeight = Math.max(0, windowHeight - viewportHeight);
    const keyboardOpen = keyboardHeight > 80; // umbral: 80px mínimos para considerarlo teclado

    return { viewportHeight, keyboardOpen, keyboardHeight };
};

export default useVisualViewport;
